import fetch from '../utils/fetch'

export function getHomeVideoZone () {
  return fetch({
    url: '/home/video-zone',
    method: 'get'
  })
}

export function saveHomeVideoZone (params) {
  return fetch({
    url: '/home/video-zone',
    method: 'put',
    params
  })
}
